import Tutorial from './Tutorial';
import common from '../../common';
import {translate} from '../../utils';

export default class TutorialLevel3 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();
		this._commands.ui.interactive = false;
		this._commands.ui.interactiveChildren = false;

		this._scene.runButton.position.y = common.STAGE_HEIGHT - 240;

		let lastTween = null;

		if (this.stage === 0) {
			this._finger.rotation = 0;
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.position.set(this._scene.cameraButton.x + 50, this._scene.cameraButton.y + 50);
			this._scene.cameraButton.interactive = true;
			common.focusOverlay.focusSprite(this._scene.cameraButton, true);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE3.ACTIVATE_OVERHEAD');
			this.signals.update.dispatch();

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
				.delay(500)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
				.delay(500)
				.start();
		} else if (this.stage === 1) {
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 200, (common.STAGE_HEIGHT * 0.5));
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._scene.cameraButton.interactive = false;
			common.focusOverlay.setFocus(0, 0, P3.View.width, P3.View.height);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE3.SWIPE');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween({rotation: 0}, this.tweens)
				.to({
					rotation: 360
				}, 1500)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.onUpdate((v) => {
					const x = 200 * Math.cos(v.rotation * PIXI.DEG_TO_RAD);
					const y = 200 * Math.sin(v.rotation * PIXI.DEG_TO_RAD);

					this._finger.position.set((common.STAGE_WIDTH * 0.5) + x, ((common.STAGE_HEIGHT * 0.5)) + y);
				})
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					alpha: 0
				}, 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None);

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 2) {
			this._finger.rotation = 0;
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.position.set(this._scene.cameraButton.x + 50, this._scene.cameraButton.y + 50);
			this._scene.cameraButton.interactive = true;
			common.focusOverlay.focusSprite(this._scene.cameraButton, true);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE3.DEACTIVATE_OVERHEAD');
			this.signals.update.dispatch();

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
				.delay(500)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
				.delay(500)
				.start();
		} else {
			common.focusOverlay.visible = false;
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this.tweens.removeAll();
			this._scene.runButton.y = common.STAGE_HEIGHT - 100;
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 1, () => {
					this.play();
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();
	}
}
